import type { IRadioButton } from '@/components/RadioButtonController/RadioButton/RadioButton.types'

export const useHasRadios = () => {
  const { t } = useI18n()

  function yesOrNoRadios(id: string): IRadioButton[] {
    return [
      {
        id: `${id}-0`,
        label: t('form.no'),
        value: false,
      },
      {
        id: `${id}-1`,
        label: t('form.yes'),
        value: true,
      },
    ]
  }

  const hasOc = yesOrNoRadios('hasOc')
  const hasPermits = yesOrNoRadios('hasPermits')
  const hasSafetyEquipment = yesOrNoRadios('hasSafetyEquipment')
  const hasReception = yesOrNoRadios('hasReception')
  const isAutonomous = yesOrNoRadios('isAutonomous')

  return {
    hasOc,
    hasPermits,
    hasSafetyEquipment,
    hasReception,
    isAutonomous,
  }
}
